const $ = jQuery;

const DEBUG_B2B = true;
console.log('b2b')
// Same host, B2B in subdirectory
const B2B_BASE = `${window.location.origin}/b2b`;
const loginUrl = `${B2B_BASE}/wp-json/spraga-b2b/v1/login`;
const registerUrl = `${B2B_BASE}/wp-json/spraga-b2b/v1/register`;

const COLLAPSE_MQ = window.matchMedia('(max-width: 849.5px)');
const COLLAPSE_ANIM_MS = 250;

const t = (key, fallback = '') => (window.SPRAGA_I18N && SPRAGA_I18N[key]) || fallback || key;


function setGlobalB2BFieldMessages() {
    if (!$.validator) return;

    $.validator.addMethod("validPhone", function(value, element) {
        return this.optional(element) || /^[\+]?[0-9\s\-\(\)]{7,20}$/.test(value);
    }, "Please enter a valid phone number.");

    const fieldMessages = {
        email: {
            required: t("enter_your_email", "Please enter your email."),
            email: t("enter_valid_email", "Please enter a valid email.")
        },
        username: {
            required: t("enter_your_email", "Please enter your email."),
            email: t("enter_valid_email", "Please enter a valid email.")
        },
        phone: {
            required: t("enter_your_phone_number", "Please enter your phone number."),
            validPhone: t("enter_valid_phone_format", "Please enter a valid phone number.")
        },

        password: { required: t("enter_your_password", "Please enter your password.") },
        b2bking_custom_field_1942: { required: t("enter_your_name", "Please enter your name.") },
        b2bking_custom_field_1944: { required: t("enter_your_company_name", "Please enter your company name.") },
        b2bking_custom_field_1945: { required: t("enter_your_street_address", "Please enter your street address.") },
        b2bking_custom_field_1943: { required: t("enter_your_nickname", "Please enter your nickname.") },

        billing_state: { required: t("enter_your_country", "Please enter your country.") },
        b2bking_custom_field_1947: { required: t("enter_your_town_or_city", "Please enter your town/city.") },
        b2bking_custom_field_1948: { required: t("enter_your_postcode", "Please enter your postcode.") },

        b2bking_custom_field_1949: {
            required: t("enter_your_phone_number", "Please enter your phone number."),
            validPhone: t("enter_valid_phone_format", "Please enter a valid phone number.")
        },
        b2bking_custom_field_1951: { required: t("enter_your_vat", "Please enter your VAT.") }
    };

    // Merge messages into defaults (won’t break your existing validation)
    $.validator.setDefaults({
        messages: fieldMessages
    });
}

function getCollapseParts(wrapper) {
    const btn = wrapper.querySelector('.b2b-form-toggle');
    if (!btn) return { btn: null, panel: null };

    const panelId = btn.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : wrapper.querySelector('.b2b-form-collapse');

    return { btn, panel };
}

function setCollapsedState(wrapper, collapsed, opts = {}) {
    const { btn, panel } = getCollapseParts(wrapper);
    if (!btn || !panel) return;

    const animate = opts.animate !== false; // default true
    const $panel = $(panel);

    if (!COLLAPSE_MQ.matches) {
        // Desktop: always expanded, no collapse
        wrapper.classList.remove('is-collapsed');
        btn.setAttribute('aria-expanded', 'true');

        panel.removeAttribute('hidden');
        $panel.stop(true, true).show(); // no animation
        return;
    }

    wrapper.classList.toggle('is-collapsed', !!collapsed);
    btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');

    if (collapsed) {
        // slideUp, then set hidden
        if (!animate) {
            $panel.stop(true, true).hide();
            panel.setAttribute('hidden', 'hidden');
            return;
        }

        $panel.stop(true, true).slideUp(COLLAPSE_ANIM_MS, () => {
            panel.setAttribute('hidden', 'hidden');
        });
    } else {
        // remove hidden first, then slideDown
        panel.removeAttribute('hidden');

        if (!animate) {
            $panel.stop(true, true).show();
            return;
        }

        $panel.stop(true, true).slideDown(COLLAPSE_ANIM_MS);
    }
}

function ensureExpanded(wrapper) {
    setCollapsedState(wrapper, false);
}

function initB2BCollapses() {
    const wrappers = document.querySelectorAll('.b2b-custom-registration-form, .b2b-custom-login-form, .custom-partners-form');

    wrappers.forEach((wrapper) => {
        const { btn, panel } = getCollapseParts(wrapper);
        if (!btn || !panel) return;

        // 1. Always update state to match current screen size
        setCollapsedState(wrapper, COLLAPSE_MQ.matches, { animate: false });

        // 2. Avoid double event listeners
        if (wrapper.dataset.b2bCollapseInited === '1') return;
        wrapper.dataset.b2bCollapseInited = '1';

        const headerRow = wrapper.querySelector('.b2b-form-header-row');
        if (!headerRow) return;

        function toggle() {
            const isCollapsed = wrapper.classList.contains('is-collapsed');
            setCollapsedState(wrapper, !isCollapsed, { animate: true });
        }

        function isInteractive(el) {
            if (!el) return false;
            return !!el.closest('a, button, input, select, textarea, label, [role="button"], [role="link"]');
        }

        // Whole header row toggles
        headerRow.addEventListener('click', (e) => {
            if (!COLLAPSE_MQ.matches) return;
            if (isInteractive(e.target)) return;

            e.preventDefault();
            toggle();
        });

        // Button toggles too (avoid double toggle)
        btn.addEventListener('click', (e) => {
            if (!COLLAPSE_MQ.matches) return;

            e.preventDefault();
            e.stopPropagation();
            toggle();
        });
    });

    // Keep state correct on resize/orientation change
    if (typeof COLLAPSE_MQ.addEventListener === 'function') {
        COLLAPSE_MQ.addEventListener('change', () => initB2BCollapses());
    } else if (typeof COLLAPSE_MQ.addListener === 'function') {
        COLLAPSE_MQ.addListener(() => initB2BCollapses());
    }
}

function dbg(...args) {
    if (!DEBUG_B2B) return;
    console.log('[B2B BRIDGE]', ...args);
}

function group(title, fn) {
    if (!DEBUG_B2B) return fn();
    console.groupCollapsed(`[B2B BRIDGE] ${title}`);
    try { fn(); } finally { console.groupEnd(); }
}

function collectFormData(form) {
    const data = {};
    const fields = form.querySelectorAll('input, select, textarea');

    fields.forEach(el => {
        const name = el.getAttribute('name');
        if (!name) return;

        if (el.type === 'checkbox') {
            data[name] = el.checked ? (el.value || '1') : '';
            return;
        }

        if (el.type === 'radio') {
            if (el.checked) data[name] = el.value;
            return;
        }

        data[name] = el.value;
    });

    return data;
}

function isValidByJqValidation(form) {
    // If jQuery Validation is present, use it
    if ($.fn && typeof $.fn.valid === 'function') {
        try {
            return $(form).valid();
        } catch (e) {
            return true;
        }
    }

    // Fallback to native validation if available
    if (typeof form.checkValidity === 'function') {
        return form.checkValidity();
    }

    return true;
}

function setSubmitLoading(form, isLoading) {
    const btn =
        form.querySelector('button[type="submit"]') ||
        form.querySelector('input[type="submit"]');

    if (!btn) return;

    if (isLoading) {
        btn.classList.add('is-b2b-loading');
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-busy', 'true');
    } else {
        btn.classList.remove('is-b2b-loading');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
    }
}

async function safeJson(res) {
    try {
        return await res.json();
    } catch (e) {
        return null;
    }
}

function showInlineError(wrapper, messageHtml) {
    // Ensure the panel is visible on mobile
    ensureExpanded(wrapper);

    const box = wrapper.querySelector('.b2b-form-error');
    if (!box) {
        alert(messageHtml.replace(/<[^>]*>/g, ''));
        return;
    }
    box.innerHTML = messageHtml;
    box.removeAttribute('hidden');
}

function clearInlineError(wrapper) {
    const box = wrapper.querySelector('.b2b-form-error');
    if (!box) return;
    box.textContent = '';
    box.setAttribute('hidden', 'hidden');
}

function handleB2BLogin(wrapper) {
    const form = wrapper.querySelector('form.wpcf7-form');
    if (!form) {
        dbg('LOGIN: CF7 form not found inside wrapper');
        return;
    }

    dbg('LOGIN: form found');

    form.addEventListener('submit', async (e) => {
        console.log('submit');
        // Hard-stop CF7 default submit flow
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
        }

        clearInlineError(wrapper);

        // Run validation first
        if (!isValidByJqValidation(form)) {
            dbg('LOGIN: validation failed');
            return;
        }

        const payload = collectFormData(form);

        const body = {
            username: payload.username || payload.email || payload.user_login || '',
            password: payload.password || '',
            remember: !!payload.rememberme,
        };

        group('LOGIN payload', () => dbg(payload));
        group('LOGIN mapped body', () => dbg(body));

        setSubmitLoading(form, true);

        try {
            dbg('LOGIN fetch ->', loginUrl);

            const res = await fetch(loginUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(body),
            });

            const json = await safeJson(res);

            dbg('LOGIN status', res.status);
            group('LOGIN response json', () => dbg(json));

            if (!json) {
                showInlineError(wrapper, 'Login failed');
                return;
            }

            if (!res.ok || !json.success) {
                showInlineError(wrapper, json.message || 'Login failed');
                return;
            }

            const redirect = json.redirect || `${B2B_BASE}/my-account/`;
            dbg('LOGIN redirecting to', redirect);

            window.location.href = redirect;

        } catch (err) {
            console.error('[B2B BRIDGE] LOGIN error', err);
            showInlineError(wrapper, json.message || 'Login error');
        } finally {
            setSubmitLoading(form, false);
        }

    }, true);
}

function handleB2BRegister(wrapper) {
    const form = wrapper.querySelector('form.wpcf7-form');
    if (!form) {
        dbg('REGISTER: CF7 form not found inside wrapper');
        return;
    }

    dbg('REGISTER: form found');

    const successBlock = wrapper.querySelector('.b2b-registration-success');
    dbg('REGISTER: successBlock', !!successBlock);

    form.addEventListener('submit', async (e) => {
        // Hard-stop CF7 default submit flow
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
        }

        clearInlineError(wrapper);

        // Run validation first
        if (!isValidByJqValidation(form)) {
            dbg('REGISTER: validation failed');
            return;
        }

        const payload = collectFormData(form);

        // Defaults required by your PHP bridge
        payload.b2bking_registration_roles_dropdown =
            payload.b2bking_registration_roles_dropdown || 'role_1941';

        payload.b2bking_country_registration_field_number =
            payload.b2bking_country_registration_field_number || '1950';

        payload.b2bking_vat_number_registration_field_number =
            payload.b2bking_vat_number_registration_field_number || '1951';

        group('REGISTER payload (after defaults)', () => dbg(payload));

        setSubmitLoading(form, true);

        try {
            dbg('REGISTER fetch ->', registerUrl);

            const res = await fetch(registerUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(payload),
            });

            const json = await safeJson(res);

            dbg('REGISTER status', res.status);
            group('REGISTER response json', () => dbg(json));

            if (!json) {
                showInlineError(wrapper, 'Registration failed');
                return;
            }

            if (!res.ok || !json.success) {
                showInlineError(wrapper, json.message || 'Registration failed');
                return;
            }

            // UI flow: hide form body and show success block
            const bodyWrap = form.closest('.b2b-form-body');

            if (bodyWrap) {
                bodyWrap.setAttribute('hidden', 'hidden');
            }

            if (successBlock) {
                successBlock.removeAttribute('hidden');
                ensureExpanded(wrapper);
            } else {
                alert(json.message || 'Registration sent');
            }

        } catch (err) {
            console.error('[B2B BRIDGE] REGISTER error', err);
            showInlineError(wrapper, json.message || 'Registration error');
        } finally {
            setSubmitLoading(form, false);
        }

    }, true);
}

function handleCommonCF7(wrapper) {
    const form = wrapper.querySelector('form.wpcf7-form');
    if (!form) return;

    const errorBox = wrapper.querySelector('.b2b-form-error');
    const successBlock = wrapper.querySelector('.b2b-registration-success');
    const bodyWrap = form.closest('.b2b-form-body');

    // CF7 events
    form.addEventListener('wpcf7invalid', (event) => {
        if (errorBox) {
            errorBox.innerHTML = event.detail.message;
            errorBox.removeAttribute('hidden');
            ensureExpanded(wrapper);
        }
    });

    form.addEventListener('wpcf7mailsent', (event) => {
        if (errorBox) errorBox.setAttribute('hidden', 'hidden');

        if (bodyWrap) bodyWrap.setAttribute('hidden', 'hidden');
        if (successBlock) {
            successBlock.removeAttribute('hidden');
            ensureExpanded(wrapper);
        }
    });

    form.addEventListener('wpcf7mailfailed', (event) => {
        if (errorBox) {
            errorBox.innerHTML = event.detail.message || 'Error sending message';
            errorBox.removeAttribute('hidden');
            ensureExpanded(wrapper);
        }
    });

    form.addEventListener('wpcf7submit', () => {
        if (errorBox) {
            errorBox.setAttribute('hidden', 'hidden');
        }
    });
}

// Anchor clicks only inside .anchor-block
function getOffsetTop() {
    const header = document.querySelector('.header');
    const topBar = document.querySelector('.top-bar-text-line');

    const headerH = header ? header.getBoundingClientRect().height : 0;
    const topBarH = topBar ? topBar.getBoundingClientRect().height : 0;

    return headerH + topBarH;
}

function getTargetFromHash(hash) {
    if (!hash || hash === '#') return null;

    // Try raw id first
    let target = document.getElementById(hash.slice(1));

    // Fallback: try decoded hash
    if (!target) {
        try {
            const decoded = decodeURIComponent(hash.slice(1));
            target = document.getElementById(decoded);
        } catch (e) {}
    }

    // Fallback: name anchor
    if (!target) {
        target = document.querySelector(`[name="${CSS.escape(hash.slice(1))}"]`);
    }

    return target;
}

function scrollToTarget(target) {
    const offset = getOffsetTop();
    const rect = target.getBoundingClientRect();
    const top = window.pageYOffset + rect.top - offset;

    window.scrollTo({
        top: Math.max(top, 0),
        behavior: 'smooth'
    });
}

function onAnchorClick(e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    if (!href.startsWith('#')) return;

    const target = getTargetFromHash(href);
    if (!target) return;

    e.preventDefault();
    e.stopPropagation();

    scrollToTarget(target);

    // Optional: update URL without jump
    if (history.replaceState) {
        history.replaceState(null, '', href);
    }
}

document.addEventListener('click', function (e) {
    const container = e.target.closest('.anchor-block');
    if (!container) return;
    onAnchorClick(e);
});

function initPasswordToggle($loginWrapper) {
    const $wrap = $loginWrapper.find('.wpcf7-form-control-wrap.password').first();
    if (!$wrap.length) return;

    const $input = $wrap.find('input').first();
    if (!$input.length) return;

    // Avoid duplicates
    if ($wrap.find('.b2b-password-toggle').length) return;

    // Ensure wrap can position absolute children via CSS if needed
    $wrap.addClass('b2b-has-password-toggle');

    const $toggle = $('<span class="b2b-password-toggle" role="button" tabindex="0" aria-label="Toggle password visibility"></span>');

    // Insert toggle inside the CF7 control wrap
    $wrap.append($toggle);

    function toggle() {
        const isActive = $toggle.hasClass('is-active');
        $toggle.toggleClass('is-active', !isActive);
        $input.attr('type', isActive ? 'password' : 'text');
    }

    $toggle.on('click', function (e) {
        e.preventDefault();
        toggle();
    });

    $toggle.on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
        }
    });
}

function initAllLoginEyes() {
    $('.b2b-custom-login-form').each(function () {
        initPasswordToggle($(this));
    });
}

// Init on ready
initAllLoginEyes();

// Re-init after CF7 lifecycle events
document.addEventListener('wpcf7init', initAllLoginEyes, false);
document.addEventListener('wpcf7reset', initAllLoginEyes, false);

$(function () {
    initB2BCollapses();
    setGlobalB2BFieldMessages();

    const loginWrappers = document.querySelectorAll('.b2b-custom-login-form');
    const regWrappers = document.querySelectorAll('.b2b-custom-registration-form');
    const partnersWrappers = document.querySelectorAll('.custom-partners-form');

    dbg('enabled');
    dbg('found login wrappers', loginWrappers.length);
    dbg('found registration wrappers', regWrappers.length);
    dbg('found partners wrappers', partnersWrappers.length);

    loginWrappers.forEach(handleB2BLogin);
    regWrappers.forEach(handleB2BRegister);
    partnersWrappers.forEach(handleCommonCF7);
});
